const positionOnWallTypes = ['first', 'second', 'last'];

export default positionOnWallTypes;
